import { render, staticRenderFns } from "./CaseInfo.vue?vue&type=template&id=7faa5ba2&"
import script from "./CaseInfo.vue?vue&type=script&lang=js&"
export * from "./CaseInfo.vue?vue&type=script&lang=js&"
import style0 from "./CaseInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports